export {
    getCaretPosition,
    setCursorPosition,
} from './inputFunction';
export { default as toOption } from './toOption';
